import React, { useEffect, useState } from "react";
import { Box, Typography, Button, Pagination } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import ModalForAddLLMAgent from "./ModalForAddLLMAgent";
import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined";
import CommonMoreActionOptionModal, { ViewTranscriptModal } from "./CommonMoreActionOptionModal";
import { DeleteLLMAgentForCallingAgent, getLLMAgentForCalligAgent } from "../../../../../contexts/WorkspaceUtils";
import CommonToast from "../../../../Common_Components/CommonToast";
import CommanModalForConformation from "../../../../Common_Components/CommanModalForConformation";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CircularLoader from "../../Track_Website/CircularLoader";

const userOptions = [
  {
    label: "Edit",
    icon: <EditIcon style={{ color: 'white' }} />,
    onClick: () => console.log("Edit")
  },
  {
    label: "Delete",
    icon: <DeleteIcon style={{ color: 'white' }} />,
    onClick: () => console.log("Delete")
  },
]

const LLMAgent = () => {
  const [openAddAgentModal, setOpenAddAgentModal] = useState();
  const [moreActionOption, setMoreActionOption] = useState(null);
  const [activeUserObject, setActiveUserObject] = useState(null);
  const [deleteModalTitle, setDeleteModalTitle] = useState("Delete LLM agent?");
  const [deleteModalMsg, setDeleteModalMsg] = useState("This LLM agent and all associated voice agents will be permanently deleted and removed from the list. This action is irreversible. Are you sure you want to proceed?");
  const [LLMEditedObject, setLLMEditedObject] = useState();
  const [LLMData, setLLMData] = useState(null);
  const [openDeleteConformationModal, setOpenDeleteConformationModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1)
  const [totalPages, setTotalPages] = useState(null);
  const [open, setOpen] = useState(false);
  const [content, setContent] = useState("");
  const [iconType, setIconType] = useState('success');
  const [loading, setLoading] = useState(false);
  const [expandedRows, setExpandedRows] = useState({});
  const [openLLMTaskModal, setOpenLLMTaskModal] = useState(false)

      const theme = createTheme({
          typography: {
            fontFamily: "Inter",
          },
          components: {
            MuiPagination: {
              styleOverrides: {
                root: {
                  "& .MuiPaginationItem-root": {
                    color: "#ffffff",
                    borderRadius: "20px",
                    "&:hover": {
                      backgroundColor: "rgba(179, 168, 183, 0.26)",
                    },
                    fontSize: "14px",
                  },
                  "& .MuiPaginationItem-page.Mui-selected": {
                    backgroundColor: "#CAC4D0",
                    color: "black",
                    "&:hover": {
                      backgroundColor: "#CAC4D0",
                    },
                  },
                  "& .MuiPaginationItem-ellipsis": {
                    color: "#ffffff",
                  },
                  "& .MuiPaginationItem-previousNext": {
                    color: "#ffffff",
                    borderRadius: "20px",
                  },
                },
              },
            },
          },
        });


        function formatDateTime(isoString) {
          const date = new Date(isoString);
        
          const day = date.getDate();
          const monthNames = [
            "January", "February", "March", "April", "May", "June",
            "July", "August", "September", "October", "November", "December"
          ];
          const month = monthNames[date.getMonth()];
          const year = date.getFullYear();
        
          let hours = date.getHours();
          const minutes = date.getMinutes().toString().padStart(2, '0');
          const ampm = hours >= 12 ? 'PM' : 'AM';
        
          hours = hours % 12;
          hours = hours ? hours : 12; // 0 should be 12
        
          return `${day} ${month} ${year}, ${hours}:${minutes} ${ampm}`;
        }
  
        const toggleExpanded = (row) => {
          setActiveUserObject(row)
          setOpenLLMTaskModal(true)
        };

        
        const getShortText = (text, maxChars = 300) => {
          const short = text?.slice(0, maxChars);
          return short + (text?.length > maxChars ? "..." : "");
        };

        const HandleViewTranscriptModalCloseClick = () => {
          setActiveUserObject(null)
          setOpenLLMTaskModal(false);
        };


  const data = [
    {
      Label: "Emma",
      slable: "voiceagents-1ae19ad7-c4f3-4c0e-a632-000c4aad6e0d",
      Agent: "Cameron Williamson",
      Persona: `Always keep the tone of the call polite, confident and fun "Hello, this is Emma from Big money Mortgage. Am I speaking ... Show more`,
      Type: "Emma - Mortgage",
      Updated: "3/20/2025 11:00PM",
      Actions: "all",
    },
    {
      Label: "Agent Vic",
      slable: "voiceagents-1ae19ad7-c4f3-4c0e-a632-000c4aad6e0d",
      Type: "Cameron Williamson",
      Persona: `Always keep the tone of the call polite, confident and fun "Hello, this is Emma from Big money Mortgage. Am I speaking ... Show more`,
      Agent: "VIC",
      Updated: "3/20/2025 11:00PM",
      Actions: "all",
    },
    {
      Label: "Ryan",
      slable: "voiceagents-1ae19ad7-c4f3-4c0e-a632-000c4aad6e0d",
      Type: "Cameron Williamson",
      Persona: `Always keep the tone of the call polite, confident and fun "Hello, this is Emma from Big money Mortgage. Am I speaking ... Show more`,
      Agent: "Real Estate Specialist",
      Updated: "3/20/2025 11:00PM",
      Actions: "all",
    },
  ];

  const GetLLMData = async () =>{
    setLoading(true)
    try{
      const res = await getLLMAgentForCalligAgent(currentPage);
      const LlmData = await res?.json();
      if(LlmData?.status){
          // console.log("LlmData",LlmData?.data)
          setLLMData(LlmData?.data?.data)
          setTotalPages(LlmData?.data?.pagination?.total_pages)
      }else{
        setOpen(true);
        setContent(LlmData?.message);
        setIconType('error');
      }
    }catch(error){
      console.log(error)
      setOpen(true);
      setContent(error?.message);
      setIconType('error');
    }
    setLoading(false)
  }

  useEffect(()=>{
    GetLLMData()
  },[currentPage])

  const HandleCloseButtonClick = () => {
    setActiveUserObject(null)
    setOpenAddAgentModal(false);
  };

  const HandleAddAgentButtonClick = () => {
    setOpenAddAgentModal(true);
  };

  const HandleMoreOptionButtonClick = (event, object) => {
    event.stopPropagation();
    // console.log("delete object", object)
    setActiveUserObject(object)
    // setMoreActionOption(true)
    setMoreActionOption(event.currentTarget); // Get button element
  };

  const handleToastClose = () =>{
      setOpen(false)
  }

  const HandleCancelDeleteLLM =async () =>{
    setActiveUserObject(null)
    setOpenDeleteConformationModal(false)
  }

  const HandleConfirmDeleteLLM = async () =>{
    setOpenDeleteConformationModal(false)
    setMoreActionOption(false)
    try{
      const jsonRespData = await DeleteLLMAgentForCallingAgent(activeUserObject?.id)
      const response = await jsonRespData.json()
      if(response?.status){
        setOpen(true);
        setContent(response?.message);
        setIconType('success');
        setActiveUserObject(null)
        await GetLLMData()
    }else{
      setOpen(true);
      setContent(response?.message);
      setIconType('error');
    }
    }catch(error){
      console.log(error)
      setOpen(true);
      setContent(error?.message);
      setIconType('error');
    }
  }

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  return (
    <div>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
        }}
      >
        <Typography variant="h4" sx={{fontFamily:"Inter", fontSize:"24px", fontStyle:"normal", fontWeight:600, lineHeight:"20px", color:"#ffffff", opacity:0.90}}>LLM Agents</Typography>
        <Box sx={{ display: "flex", flexDirection: "row", columnGap: "20px" }}>
          <Button
            onClick={HandleAddAgentButtonClick}
            sx={{
              width: "120px",
              maxWidth: "120px",
              height: "40px",
              textTransform: "none",
              fontFamily: "Inter",
              fontSize: "16px",
              fontWeight: 600,
              textAlign: "center",
              bgcolor: "rgba(246, 190, 107, 1)",
              color: "rgba(23, 24, 44, 1)",
              borderRadius: "8px",
              "&:hover": {
                backgroundColor: "#ffd9aa",
              },
              // "&.Mui-disabled": {
              //   color: "rgba(230, 224, 233, 1)", // Custom color for the disabled state
              //   bgcolor:(subscribe && subscribeType === 4) ? "rgba(230, 224, 233, 0.12)" : "rgba(40, 45, 81, 1)"
              // },
            }}
          >
            Add agent
          </Button>
        </Box>
      </Box>
      {/* Contacts content goes here */}
      <Box
                      sx={{
                        border: "1px solid rgba(255, 255, 255, 0.10)",
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                        backgroundColor: "#171A2D",
                        marginTop: "40px",
                        padding: "20px",
                        borderRadius: "16px",
                        maxHeight:"600px",
                        overflowY:"auto"
                      }}
                    >
      <Box>
        {
                  loading ? 
                     <CircularLoader  msg={"Loading LLM..."} /> 
                :

                <TableContainer>
                  <Table sx={{ fontFamily: "Inter", color: "#ffffff" }}>
                    <TableHead>
                      <TableRow sx={{borderBottom: "1px solid rgba(255, 255, 255, 0.10)"}}>
                        <TableCell
                          align="left"
                          sx={{
                            fontFamily: "Inter",
                            color: "#ffffff",
                            padding: "20px 24px",
                            borderBottom: "none",
                          }}
                        >
                          Title
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            fontFamily: "Inter",
                            color: "#ffffff",
                            padding: "20px 24px",
                            borderBottom: "none",
                          }}
                        >
                          Agent name
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            fontFamily: "Inter",
                            color: "#ffffff",
                            padding: "20px 24px",
                            borderBottom: "none",
                          }}
                        >
                          Type
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            fontFamily: "Inter",
                            color: "#ffffff",
                            padding: "20px 24px",
                            borderBottom: "none",
                          }}
                        >
                          Task
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            fontFamily: "Inter",
                            color: "#ffffff",
                            padding: "20px 24px",
                            borderBottom: "none",
                          }}
                        >
                          Updated at
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{
                            fontFamily: "Inter",
                            color: "#ffffff",
                            padding: "20px 24px",
                            borderBottom: "none",
                          }}
                        >
                          Actions
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {LLMData?.map((row) => (
                        <TableRow
                          key={row.id}
                          sx={{  "&:last-child td, &:last-child th": { border: 0 }, }}
                        >
                            <TableCell
                              align="left"
                              sx={{
                                fontFamily: "Inter",
                                padding: "20px 24px",
                                borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                                color:"#CAC4D0"
                              }}
                            >
                              {row?.title}
                              {/* <br />
                              <spam style={{ color: "rgba(255, 255, 255, 0.60)" }}>
                                {row.slable}
                              </spam> */}
                            </TableCell>
                          <TableCell
                            align="left"
                            sx={{
                              fontFamily: "Inter",
                              color: "#ffffff",
                              padding: "20px 24px",
                              borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                            }}
                          >
                            {row?.name}
                          </TableCell>
                          <TableCell
                            align="left"
                            sx={{
                              fontFamily: "Inter",
                              color: "#ffffff",
                              padding: "20px 24px",
                              borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                            }}
                          >
                            {row?.type}
                          </TableCell>
                          {/* <TableCell
                            align="left"
                            sx={{
                              fontFamily: "Inter",
                              color: "#ffffff",
                              padding: "20px 24px",
                              borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                            }}
                          >
                            {row?.tasks}
                          </TableCell> */}
                          <TableCell
                              align="left"
                              sx={{
                                fontFamily: "Inter",
                                color: "#ffffff",
                                padding: "20px 24px",
                                borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                                whiteSpace: "pre-wrap", // Keep line breaks
                                maxWidth: 500,
                              }}
                            >
                              {expandedRows[row.id] ? row.tasks : getShortText(row.tasks)}

                              {row.tasks.length > 300 && (
                                <Box
                                  component="span"
                                  sx={{ color: "#ffffff", cursor: "pointer", ml: 1, textDecorationLine:"underline" }}
                                  onClick={() => toggleExpanded(row)}
                                >
                                  {"Show More"}
                                </Box>
                              )}
                            </TableCell>
                          <TableCell
                            align="left"
                            sx={{
                              fontFamily: "Inter",
                              color: "#ffffff",
                              padding: "20px 24px",
                              borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                            }}
                          >
                            {formatDateTime(row?.updated_at)}
                          </TableCell>
                          <TableCell
                            align="left"
                            sx={{
                              fontFamily: "Inter",
                              color: "#ffffff",
                              padding: "20px 24px",
                              borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
                            }}
                          >
                            <Box>
                              <Button
                                onClick={(e)=>{HandleMoreOptionButtonClick(e, row)}}
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "center",
                                  borderRadius: "50%",
                                  alignItems: "center",
                                  maxWidth: "36px",
                                  minWidth: "36px",
                                  height: "36px",
                                  bgcolor: "#1F233E",
                                  padding: "8px",
                                }}
                              >
                                <MoreVertOutlinedIcon
                                  sx={{
                                    color: "#CAC4D0",
                                    width: "20px",
                                    height: "20px",
                                    bgcolor: "#1F233E",
                                  }}
                                />
                              </Button>
                            </Box>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
        }
        </Box>
      </Box>
        <div className="d-flex justify-content-center mt-3">
                                <ThemeProvider theme={theme}>
                                  <Pagination
                                    count={totalPages} // Total number of pages
                                    page={currentPage} // Current page
                                    siblingCount={1} // Show one previous and one upcoming page
                                    boundaryCount={1} // Show first and last page buttons
                                    onChange={handlePageChange} // Handle page change
                                    shape="rounded" // Rounded buttons
                                    size="large" // Larger buttons
                                  />
                                </ThemeProvider>
                              </div>
      <ModalForAddLLMAgent
        openAddAgentModal={openAddAgentModal}
        setOpenAddAgentModal={setOpenAddAgentModal}
        HandleCloseButtonClick={HandleCloseButtonClick}
        fetchData={GetLLMData}
        activeUserObject={activeUserObject}
        setMoreActionOption={setMoreActionOption}
      />
      <CommonMoreActionOptionModal
        showModal={moreActionOption}
        setShowModal={setMoreActionOption}
        options={userOptions}
        setOpenDeleteConformationModal={setOpenDeleteConformationModal}
        openEditedModal={setOpenAddAgentModal}
        setActiveUserObject={setActiveUserObject}
        activeUserObject={activeUserObject}
      />
      <CommonToast  open={open} onClose={handleToastClose} content={content} iconType={iconType} bgColor={"#282D51"}/>
      <CommanModalForConformation open={openDeleteConformationModal} modalTitle={deleteModalTitle} modalMessage={deleteModalMsg} handleConfirm={HandleConfirmDeleteLLM} handleCancel={HandleCancelDeleteLLM}/>
      <ViewTranscriptModal showViewTranscriptModal={openLLMTaskModal} HandleViewTranscriptModalCloseClick={HandleViewTranscriptModalCloseClick} Content={activeUserObject?.tasks} Title={"Task"}/>
    </div>
  );
};

export default LLMAgent;
